export const wishTexts: { [key: string]: string } = {
  tanya: "Одного грозного мопса",
  "mama-d": "Не слушать ничьих советов",
  varya: "Антону вечно любить Дашу",
  "liza-1": "Поехать в Британию",
  iliya: "Вечный запас еды для сериалов",
  ksusha: "33 ребёнка и 33 работы",
  roditely: "Домработницу и дворецкого",
  "liza-2": "Больше отдыхать",
  nastya: "Не встречать своих коллег на улице",
  "papa-a": "Никакой зимы в жизни",
};
